import React, { useContext } from 'react';
import { Row, Squish, grubhubLight } from '@grubhubprod/gh-cookbook-react';
import { DataTableSelectionContext } from 'src/components/DataTable/components/DataTableSelectionProvider/DataTableSelectionContext';
import { hexToRgba } from 'src/utilities/color-utils';

export interface DataTableRowProps {
  id?: string;
}

export const DataTableRow: React.FC<DataTableRowProps> = ({ id, children }) => {
  const selectionContext = useContext(DataTableSelectionContext);
  const isSelected =
    selectionContext && id ? selectionContext.isSelected(id) : false;

  return (
    <Squish
      inset="md"
      borderTop="1px solid"
      borderColor="lightLine"
      role="row"
      {...(isSelected && {
        bg: hexToRgba(grubhubLight.colors.interactive, 0.08),
      })}
    >
      <Row gutter={12}>{children}</Row>
    </Squish>
  );
};
